import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import Vectors from './pages/Vectors';
import TimeSeries from './pages/TimeSeries';
import RealTime from './pages/RealTime';
import Analytics from './pages/Analytics';
import './index.css';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    // Test EdgeVector connectivity on app start
    const testConnection = async () => {
      try {
        const response = await fetch('https://edgevector-db.finhub.workers.dev/api/v1/health');
        const data = await response.json();
        console.log('✅ EdgeVector connection successful:', data);
      } catch (error) {
        console.error('❌ EdgeVector connection failed:', error);
      }
    };

    testConnection();
  }, []);

  return (
    <div className='min-h-screen bg-gradient-to-br from-gray-50 to-white'>
      <Header activeTab={activeTab} onTabChange={setActiveTab} />

      <main className='container mx-auto px-4 py-8'>
        <Routes>
          <Route path='/' element={<Dashboard />} />
          <Route path='/documents' element={<Documents />} />
          <Route path='/vectors' element={<Vectors />} />
          <Route path='/timeseries' element={<TimeSeries />} />
          <Route path='/realtime' element={<RealTime />} />
          <Route path='/analytics' element={<Analytics />} />
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
